export default __webpack_public_path__ + "static/media/content.3eed561c.txt";